import { WebPagesContract } from '@terra/shared-contracts-web-pages';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'orchestrator';

export const webPagesClient = createTerraOrpcClient({
  contract: WebPagesContract,
  serviceName: SERVICE_NAME,
});
